import { OnboardingNodeType, OnboardingStepType } from '../steps/types';
import { OnboardingSteps } from '../types';

const getSubmittedData = <T>(
  nodeType: OnboardingNodeType,
  stepType: OnboardingStepType,
  steps: OnboardingSteps
): T | undefined => {
  const onboardingSteps = steps[nodeType];

  if (!onboardingSteps) {
    return undefined;
  }

  const target = onboardingSteps.find((step) => step.uid === stepType);
  if (!target) {
    return undefined;
  }

  return (target.payload as T) ?? undefined;
};

export default getSubmittedData;
